import React from "react"
import AsyncSelect from "react-select/async"

import theme from "theme"
import { customReactSelectStyles } from "components/form/select/styles"
import { OptionsType } from "react-select/src/types"
import { Option } from "typings/select-options"

export type AsyncSelectProps = GetComponentProps<AsyncSelect<OptionsType<Option<string>>>> & {
  placeholderFontSize?: number
}

const Select: React.FC<AsyncSelectProps> = ({
  options,
  disabled,
  onChange,
  placeholder,
  selectedOptions,
  components,
  loadOptions,
  placeholderFontSize,
  error = false
}) => (
  <AsyncSelect
    value={selectedOptions}
    options={options}
    loadOptions={loadOptions}
    onChange={onChange}
    styles={customReactSelectStyles({
      error,
      placeholderFontSize,
      optionFontStyles: { fontFamily: theme.fonts.paragraph, textTransform: "capitalize" }
    })}
    placeholder={placeholder}
    isDisabled={disabled}
    noOptionsMessage={() => "Start typing..."}
    components={components}
    isSearchable
  />
)

export default Select
